import "./app.scss";

// Parcel entrypoint for incremental, non-legacy enhancements.
const modal = document.querySelector("[data-medical-modal]");
const openButtons = document.querySelectorAll("[data-medical-modal-open]");
const closeButtons = document.querySelectorAll("[data-medical-modal-close]");
const elapsedTimerControllers = [];
const syncBodyModalLock = () => {
  const hasOpenModal = Boolean(
    document.querySelector(".seh-modal.is-open, .seh-confirm-modal.is-open")
  );
  document.body.classList.toggle("seh-modal-open", hasOpenModal);
};

if (modal && openButtons.length > 0) {
  const setModalState = (isOpen) => {
    modal.classList.toggle("is-open", isOpen);
    modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    syncBodyModalLock();
  };

  openButtons.forEach((button) => {
    button.addEventListener("click", () => setModalState(true));
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => setModalState(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      setModalState(false);
    }
  });
}

const elapsedTimers = document.querySelectorAll("[data-elapsed-timer]");
const emergencyMedicationModal = document.querySelector(
  "[data-emergency-medication-modal]"
);
const call112Modal = document.querySelector("[data-call-112-modal]");
const call112CloseButtons = document.querySelectorAll("[data-call-112-close]");
const emergencyMedicationCloseButtons = document.querySelectorAll(
  "[data-emergency-medication-close]"
);
const emergencyMedicationCheckbox = document.getElementById(
  "emergency-medication-checkbox"
);
const emergencyMedicationNotQualifiedCheckbox = document.getElementById(
  "emergency-medication-not-qualified-checkbox"
);
const emergencyMedicationCanAdministerGroup = document.querySelector(
  ".seh-confirm-modal__can-administered"
);
const emergencyMedicationConfirmButton = document.querySelector(
  "[data-emergency-medication-confirm]"
);
const emergencyMedicationNotAdministeredButton = document.querySelector(
  "[data-emergency-medication-not-administered]"
);
const emergencyMedicationStepGroup = document.querySelector(
  ".emergency-medication-step-group"
);

const setEmergencyMedicationModalState = (isOpen) => {
  if (!emergencyMedicationModal) {
    return;
  }
  emergencyMedicationModal.classList.toggle("is-open", isOpen);
  emergencyMedicationModal.setAttribute("aria-hidden", isOpen ? "false" : "true");
  syncBodyModalLock();
};

const setCall112ModalState = (isOpen) => {
  if (!call112Modal) {
    return;
  }
  call112Modal.classList.toggle("is-open", isOpen);
  call112Modal.setAttribute("aria-hidden", isOpen ? "false" : "true");
  syncBodyModalLock();
};

if (elapsedTimers.length > 0) {
  elapsedTimers.forEach((timer) => {
    const valueEl = timer.querySelector("[data-elapsed-value]");
    if (!valueEl) {
      return;
    }

    let elapsed = Number.parseInt(timer.getAttribute("data-start-seconds") || "0", 10);
    const thresholdMinutes = Number.parseInt(
      timer.getAttribute("data-emergency-medication-minutes") || "0",
      10
    );
    const call112ThresholdMinutes = Number.parseInt(
      timer.getAttribute("data-call-112-minutes") || "0",
      10
    );
    const thresholdSeconds = Number.isNaN(thresholdMinutes)
      ? 0
      : Math.max(thresholdMinutes, 0) * 60;
    const call112ThresholdSeconds = Number.isNaN(call112ThresholdMinutes)
      ? 0
      : Math.max(call112ThresholdMinutes, 0) * 60;
    let emergencyMedicationShown = false;
    let call112Shown = false;
    if (Number.isNaN(elapsed) || elapsed < 0) {
      elapsed = 0;
    }

    const renderElapsed = () => {
      const minutes = Math.floor(elapsed / 60);
      const seconds = elapsed % 60;
      valueEl.textContent = `${minutes}:${String(seconds).padStart(2, "0")}`;

      if (
        emergencyMedicationModal &&
        !emergencyMedicationShown &&
        thresholdSeconds > 0 &&
        elapsed >= thresholdSeconds
      ) {
        emergencyMedicationShown = true;
        setEmergencyMedicationModalState(true);
      }

      if (
        call112Modal &&
        !call112Shown &&
        call112ThresholdSeconds > 0 &&
        elapsed >= call112ThresholdSeconds
      ) {
        call112Shown = true;
        setCall112ModalState(true);
      }
    };

    renderElapsed();

    const intervalId = window.setInterval(() => {
      elapsed += 1;
      renderElapsed();
    }, 1000);

    elapsedTimerControllers.push(() => window.clearInterval(intervalId));
  });
}

// WooCommerce pa_type-abonnement variation selector (product page).
// Uses jQuery because WooCommerce variation JS only listens for jQuery events.
const typeSelect = document.getElementById("type_abonnement_select");
if (typeSelect && window.jQuery) {
  const $ = window.jQuery;
  $(typeSelect).on("change", function () {
    const val = $(this).val();
    $("#pa_type-abonnement").val(val).trigger("change");
  });
}

const thumbnailSlider = document.querySelector(".media-thumbnail-slider");
if (thumbnailSlider && window.jQuery) {
  const $ = window.jQuery;
  const imageBaseName = (url) =>
    (url || "")
      .split("?")[0]
      .split("/")
      .pop()
      .replace(/\.[^.]+$/, "")
      .replace(/-\d+x\d+$/, "")
      .replace(/-scaled$/, "")
      .toLowerCase();

  const findVariationThumbnail = (variation) => {
    const thumbnails = Array.from(thumbnailSlider.querySelectorAll(".media-thumbnail"));
    const byId = thumbnails.find(
      (thumbnail) => thumbnail.dataset.attachmentId === String(variation.image_id)
    );
    if (byId) {
      return byId;
    }

    const variationName = imageBaseName(variation.image && variation.image.full_src);
    if (!variationName) {
      return null;
    }

    return thumbnails.find((thumbnail) => {
      const img = thumbnail.querySelector("img");
      return img && imageBaseName(img.getAttribute("src")) === variationName;
    });
  };

  $(".single_variation_wrap").on("show_variation", (event, variation) => {
    const thumbnail = findVariationThumbnail(variation);
    if (thumbnail) {
      $(thumbnailSlider).slick("slickGoTo", Number(thumbnail.dataset.num));
    }
  });
}


const endAttackModal = document.querySelector("[data-end-attack-modal]");
const endAttackOpenButtons = document.querySelectorAll("[data-end-attack-open]");
const endAttackCloseButtons = document.querySelectorAll("[data-end-attack-close]");
const endAttackConfirmButtons = document.querySelectorAll("[data-end-attack-confirm]");

if (endAttackModal && endAttackOpenButtons.length > 0) {
  const setEndAttackModalState = (isOpen) => {
    endAttackModal.classList.toggle("is-open", isOpen);
    endAttackModal.setAttribute("aria-hidden", isOpen ? "false" : "true");
    syncBodyModalLock();
  };

  endAttackOpenButtons.forEach((button) => {
    button.addEventListener("click", () => setEndAttackModalState(true));
  });

  endAttackCloseButtons.forEach((button) => {
    button.addEventListener("click", () => setEndAttackModalState(false));
  });

  endAttackConfirmButtons.forEach((button) => {
    button.addEventListener("click", () => {
      elapsedTimerControllers.forEach((stopTimer) => stopTimer());
      setEndAttackModalState(false);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && endAttackModal.classList.contains("is-open")) {
      setEndAttackModalState(false);
    }
    if (
      event.key === "Escape" &&
      emergencyMedicationModal &&
      emergencyMedicationModal.classList.contains("is-open")
    ) {
      setEmergencyMedicationModalState(false);
    }
  });
}

if (emergencyMedicationModal && emergencyMedicationCloseButtons.length > 0) {
  emergencyMedicationCloseButtons.forEach((button) => {
    button.addEventListener("click", () => setEmergencyMedicationModalState(false));
  });
}

if (call112Modal && call112CloseButtons.length > 0) {
  call112CloseButtons.forEach((button) => {
    button.addEventListener("click", () => setCall112ModalState(false));
  });
}

if (
  emergencyMedicationCheckbox &&
  emergencyMedicationNotQualifiedCheckbox &&
  emergencyMedicationConfirmButton
) {
  const syncEmergencyMedicationConfirm = () => {
    const canAdminister = emergencyMedicationCheckbox.checked;
    const notQualified = emergencyMedicationNotQualifiedCheckbox.checked;

    emergencyMedicationConfirmButton.disabled = !canAdminister;
    emergencyMedicationConfirmButton.classList.toggle(
      "is-hidden",
      notQualified
    );
    emergencyMedicationConfirmButton.setAttribute(
      "aria-hidden",
      notQualified ? "true" : "false"
    );

    if (emergencyMedicationCanAdministerGroup) {
      emergencyMedicationCanAdministerGroup.hidden = notQualified;
      emergencyMedicationCanAdministerGroup.setAttribute(
        "aria-hidden",
        notQualified ? "true" : "false"
      );
    }

    if (emergencyMedicationNotAdministeredButton) {
      emergencyMedicationNotAdministeredButton.classList.toggle(
        "is-visible",
        notQualified
      );
      emergencyMedicationNotAdministeredButton.setAttribute(
        "aria-hidden",
        notQualified ? "false" : "true"
      );
    }

    if (emergencyMedicationStepGroup) {
      emergencyMedicationStepGroup.classList.toggle(
        "is-visible",
        canAdminister
      );
      emergencyMedicationStepGroup.setAttribute(
        "aria-hidden",
        canAdminister ? "false" : "true"
      );
    }
  };

  syncEmergencyMedicationConfirm();
  emergencyMedicationCheckbox.addEventListener("change", () => {
    if (emergencyMedicationCheckbox.checked) {
      emergencyMedicationNotQualifiedCheckbox.checked = false;
    }
    syncEmergencyMedicationConfirm();
  });

  emergencyMedicationNotQualifiedCheckbox.addEventListener("change", () => {
    if (emergencyMedicationNotQualifiedCheckbox.checked) {
      emergencyMedicationCheckbox.checked = false;
    }
    syncEmergencyMedicationConfirm();
  });
}

if (emergencyMedicationNotAdministeredButton) {
  emergencyMedicationNotAdministeredButton.addEventListener("click", () => {
    window.location.href = "tel:112";
  });
}

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && call112Modal && call112Modal.classList.contains("is-open")) {
    setCall112ModalState(false);
  }
});
